import { Button, Stack, TextField, Typography, Container, Paper} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import firebaseConfig from "../firebase";
import { getFirestore } from 'firebase/firestore';
import { addDoc, collection } from "firebase/firestore";
function AnnounceCreate() {
  const navigate = useNavigate()
  const [announceImg, setImage] = useState('');
  const [announceLink, setLink] = useState('');
  const [announceStatus, setStatus] = useState('');
  const db = getFirestore(firebaseConfig)
  const anCollectionRef = collection(db, "Announce");

  const uploadImage = async (e) => {
    const file = e.target.files[0];
    const base64 = await convertBase64(file);
    setImage(base64);
  };

  const convertBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const fileReader = new FileReader();
      fileReader.readAsDataURL(file);

      fileReader.onload = () => {
        resolve(fileReader.result);
      };

      fileReader.onerror = (error) => {
        reject(error);
      };
    });
  };

  const createAn = async () => {
    await addDoc(
      anCollectionRef,
      {
        announceImg: announceImg,
        announceLink: announceLink,
        announceStatus: announceStatus,
      }
    );
    alert("บันทึกเรียบร้อย")
    navigate('/announce');
  };
  return (
    <Container class={Paper}>
      <Stack spacing={3}>
      <Typography
          variant="h1"
          sx={{
            fontWeight: "bold",
            fontSize: "2.25vw",
            marginTop: "20px",
            fontFamily: "Prompt",
          }}
        >
          เพิ่มประกาศ
        </Typography>
        <input type="file" 
        onChange={(e) => {
          uploadImage(e);
        }}/>
        <img src={announceImg} width="200px" />


        <TextField inputProps={{ style: { fontFamily: "Prompt" } }}
          InputLabelProps={{ style: { fontFamily: "Prompt" } }}
          variant="standard" label="link*"
          onChange={(event) => {
            setLink(event.target.value);
          }} />
        <TextField inputProps={{ style: { fontFamily: "Prompt" } }}
          InputLabelProps={{ style: { fontFamily: "Prompt" } }}
          variant="standard" label="status*"
          onChange={(event) => {
            setStatus(event.target.value);
          }} />
        <Stack direction="row"  justifyContent="flex-end" spacing={3}>
        <Button  sx={{ fontFamily:'Prompt'}} onClick={() => navigate('/announce')} variant="text" color="error">ยกเลิก</Button>
          <Button sx={{ fontFamily:'Prompt'}} onClick={createAn} variant="outlined" color="success">บันทึก</Button>
        </Stack>
      </Stack>
    </Container>
  );
}

export default AnnounceCreate